import ChequeApi from "./ChequeApi";

export default ChequeApi;
